import PropTypes from 'prop-types';
// import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaCheck } from 'react-icons/fa';
import { MdLocalOffer } from 'react-icons/md';
import clsx from 'clsx';
import { memo, useCallback } from 'react';
import { useCookies } from 'react-cookie';
import Filter from '../../../../Filters/Filter';
import { HotelRateDisplayPreferenceLabels } from '../../../../../constants';
import Dropdown from '../../../../Dropdown';
import {
  hotelSearchRequest,
  setHotelRateDisplayPreference,
} from '../../../../../store/slices/tripSearch';
import { hotelSearch, updateHotelSearchObj } from '../../../../../store/slices/hotel';
import getHotelPriceDisplayPreference from '../../../../../helpers/selectors/getHotelPriceDisplayPreference';

const PricePreferenceFilter = ({ tripId }) => {
  const dispatch = useDispatch();
  const isTripSearch = !tripId;
  // oxlint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies();
  const pricePreference = useSelector(getHotelPriceDisplayPreference());

  const handleChange = useCallback(
    (selectedVal, doSetCookie = true) => {
      if (doSetCookie) {
        setCookie('hotelRateDisplayPreference', +selectedVal, { path: '/' });
      }
      dispatch(setHotelRateDisplayPreference(+selectedVal));

      if (+selectedVal !== pricePreference) {
        const payload = {
          tripId,
          searchObj: {
            fromPrice: null,
            toPrice: null,
            page: 1,
            hasFilterApplied: true,
          },
        };
        if (isTripSearch) {
          dispatch(hotelSearchRequest(payload.searchObj));
        } else {
          dispatch(updateHotelSearchObj(payload));
          dispatch(hotelSearch(payload));
        }
      }
    },
    [dispatch, isTripSearch, pricePreference, setCookie, tripId],
  );

  return (
    <Filter
      menuWidthClass="w-64"
      label={`Display: ${HotelRateDisplayPreferenceLabels[pricePreference].label}`}
      isFilterEmpty
      variant="outline"
      filterSpacingClass={isTripSearch ? 'py-2 px-3' : undefined}
      withClear={false}
      fontSize={isTripSearch ? 'text-base' : undefined}
      icon={isTripSearch ? <MdLocalOffer className="mr-1 mt-1" /> : undefined}
      filterMaxWidthClass=""
      bgClassName={!isTripSearch ? '' : undefined}
    >
      {Object.keys(HotelRateDisplayPreferenceLabels).map((item) => (
        <Dropdown.Item
          withGridLayout={false}
          key={item}
          label={HotelRateDisplayPreferenceLabels[item].label}
          value={item}
          variant="select"
        >
          <button
            type="button"
            onClick={() => handleChange(item)}
            className="p-1 focus:outline-none text-left center flex"
          >
            <div
              className={clsx('p-1 self-center justify-self-center', {
                invisible: pricePreference !== +item,
              })}
            >
              <FaCheck className="-ml-2 mr-2" />
            </div>
            <div>
              <div className="font-bold">{HotelRateDisplayPreferenceLabels[item].label}</div>
              <div>{HotelRateDisplayPreferenceLabels[item].description}</div>
            </div>
          </button>
        </Dropdown.Item>
      ))}
    </Filter>
  );
};

PricePreferenceFilter.propTypes = {
  tripId: PropTypes.string,
};

PricePreferenceFilter.defaultProps = {
  tripId: undefined,
};

export default memo(PricePreferenceFilter);
